import * as tempdataActions from '@store/tempdata/tempdata.actions';

import { OrderFilter } from '../shared/order-filter.model';
import * as orderActions from './orders.actions';

export interface OrderState {
  inquiry: {
    showing: string;
    filter: OrderFilter;
    loadedFilter: string;
    ordInqSelectedRow: any;
  };
  details: {
    showing: string;
  };
  modifyHeader: {
    showing: string;
    dataLoaded: boolean;
    orderid: number;
    shipid: number;
    updateData: string[];
    origin: string;
  };
  modifyDetails: {
    showing: string;
    dataLoaded: boolean;
    orderid: number;
    shipid: number;
    updateData: string[];
    origin: string;
  };
  filters: any;
}

export const initialState: OrderState = {
  inquiry: {
    showing: 'grid',
    filter: null,
    loadedFilter: '<null>',
    ordInqSelectedRow: null,
  },
  details: {
    showing: 'grid',
  },
  modifyHeader: {
    showing: 'main',
    dataLoaded: false,
    orderid: null,
    shipid: null,
    updateData: [],
    origin: null,
  },
  modifyDetails: {
    showing: 'grid',
    dataLoaded: false,
    orderid: null,
    shipid: null,
    updateData: [],
    origin: null,
  },
  filters: {},
};

export function orderReducer(state = initialState, action: orderActions.OrderActions) {
  switch (action.type) {
    case orderActions.ORD_INQ_INIT:
      return {
        ...initialState,
        modifyHeader: {
          ...initialState.modifyHeader,
          origin: 'inquiry',
        },
      };

    case orderActions.ORD_MOD_HDR_CREATE_INIT:
      return {
        ...initialState,
        modifyHeader: {
          ...initialState.modifyHeader,
          origin: 'create',
        },
      };

    case orderActions.ORD_INQ_REINIT:
      return {
        ...initialState,
        inquiry: {
          ...state.inquiry,
          ordInqSelectedRow: null,
        },
      };

    case orderActions.ORD_INQ_SET_FILTER:
      return {
        ...state,
        inquiry: {
          ...state.inquiry,
          filter: action.filter,
        },
      };

    case orderActions.ORD_INQ_CLEAR_FILTER:
      return {
        ...state,
        inquiry: {
          ...state.inquiry,
          filter: null,
        },
      };

    case orderActions.ORD_INQ_SET_SHOWING:
      return {
        ...state,
        inquiry: {
          ...state.inquiry,
          showing: action.area,
        },
      };

    case orderActions.ORD_INQ_SELECT_ROW:
      return {
        ...state,
        inquiry: {
          ...state.inquiry,
          ordInqSelectedRow: action.row,
        },
      };

    case orderActions.ORD_INQ_MODIFY_ROW:
      return {
        ...state,
        inquiry: {
          ...state.inquiry,
          ordInqSelectedRow: action.row,
        },
        modifyHeader: {
          ...state.modifyHeader,
          orderid: action.row.orderid,
          shipid: action.row.shipid,
          origin: 'inquiry',
        },
      };

    case orderActions.ORD_INQ_CLEAR_SELECT_ROW:
      return {
        ...state,
        inquiry: {
          ...state.inquiry,
          ordInqSelectedRow: null,
        },
      };

    case orderActions.ORD_INQ_REQUEST_DATA:
      return {
        ...state,
        inquiry: {
          ...state.inquiry,
          ordInqSelectedRow: null,
          filter: action.filter,
        },
      };

    case orderActions.ORD_INQ_CLEAR_LOADED_FILTER:
      return {
        ...state,
        inquiry: {
          ...state.inquiry,
          loadedFilter: '<null>',
        },
      };

    case orderActions.ORD_INQ_SET_LOADED_FILTER:
      return {
        ...state,
        inquiry: {
          ...state.inquiry,
          loadedFilter: action.id,
        },
      };

    case orderActions.ORD_DTL_SET_SHOWING:
      return {
        ...state,
        details: {
          ...state.details,
          showing: action.area,
        },
      };

    case orderActions.ORD_MOD_HDR_MODIFY_INIT:
      return {
        ...state,
        modifyHeader: {
          ...state.modifyHeader,
          showing: initialState.modifyHeader.showing,
          updateData: [],
        },
      };

    case orderActions.ORD_MOD_HDR_SET_SHOWING:
      return {
        ...state,
        modifyHeader: {
          ...state.modifyHeader,
          showing: action.area,
        },
      };

    case orderActions.ORD_MOD_HDR_SET_ORDER:
      return {
        ...state,
        modifyHeader: {
          ...state.modifyHeader,
          orderid: action.data.orderid,
          shipid: action.data.shipid,
          origin: 'inquiry',
        },
      };

    case orderActions.ORD_MOD_HDR_CLEAR_ORDER:
      return {
        ...state,
        modifyHeader: {
          ...state.modifyHeader,
          orderid: null,
          shipid: null,
          origin: 'inquiry',
        },
      };

    case orderActions.ORD_MOD_HDR_UPDATE_DATA:
    case orderActions.ORD_MOD_HDR_CREATE_INBOUND:
    case orderActions.ORD_MOD_HDR_CREATE_OUTBOUND:
      return {
        ...state,
        modifyHeader: {
          ...state.modifyHeader,
          updateData: action.data.qualifiers,
          origin: 'outbound',
        },
      };

    case orderActions.ORD_MOD_HDR_UPDATE_DATA_SUCCESS:
      return {
        ...state,
        modifyHeader: {
          ...state.modifyHeader,
          updateData: [],
          origin: 'inquiry',
        },
      };

    case orderActions.ORD_MOD_HDR_CREATE_INBOUND_SUCCESS:
      return {
        ...state,
        modifyHeader: {
          ...state.modifyHeader,
          updateData: [],
          dataLoaded: false,
          orderid: action.data.orderid,
          shipid: action.data.shipid,
          origin: 'create-inbound',
        },
      };

    case orderActions.ORD_MOD_HDR_CREATE_OUTBOUND_SUCCESS:
      return {
        ...state,
        modifyHeader: {
          ...state.modifyHeader,
          updateData: [],
          dataLoaded: false,
          orderid: action.data.orderid,
          shipid: action.data.shipid,
          origin: 'create-outbound',
        },
      };

    case tempdataActions.ORD_MOD_HDR_SET_DATA:
      return {
        ...state,
        modifyHeader: {
          ...state.modifyHeader,
          dataLoaded: true,
        },
      };

    case orderActions.ORD_MOD_DTL_SET_SHOWING:
      return {
        ...state,
        modifyDetails: {
          ...state.modifyDetails,
          showing: action.area,
          origin: 'header',
        },
      };

    case orderActions.ORD_MOD_DTL_UPDATE_DATA:
      return {
        ...state,
        modifyDetails: {
          ...state.modifyDetails,
          updateData: action.data,
          origin: 'header',
        },
      };

    case orderActions.ORD_SET_FILTERS:
      return {
        ...state,
        filters: action.data,
      };

    case orderActions.ORD_DTL_INIT:
    case orderActions.ORD_MOD_DTL_INIT:
    default:
      return state;
  }
}
